import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import PersonIcon from '@mui/icons-material/Person';
import {
  AppBar,
  Button,
  Grid,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useIsMaintenance } from '../../services/isMaintenance';
import { CustomButton } from '../common/button/customButton';
import { JHLogo } from './jhlogo';
import { LangMenu } from './langmenu';

export const Header = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { isLoading, isMaintenance } = useIsMaintenance();

  const { t } = useTranslation();

  return (
    <AppBar
      position="relative"
      color="secondary"
      style={{
        width: '100%',
        top: 0,
        zIndex: 2,
      }}
    >
      <Toolbar
        style={{
          height: '1em',
          backgroundColor: 'black',
          justifyContent: 'center',
          minHeight: '32px',
        }}
      >
        <Stack
          direction="row"
          justifyItems="end"
          justifyContent="flex-end"
          maxWidth="1200px"
          width="100%"
        >
          <LangMenu />
          {isAuthenticated && !isMaintenance && !isLoading && (
            <Button
              color="inherit"
              onClick={() => {
                instance.logoutRedirect({ postLogoutRedirectUri: '/' });
              }}
            >
              {t('LogOut')}
            </Button>
          )}
        </Stack>
      </Toolbar>
      <Toolbar style={{ height: '6em', justifyContent: 'center' }}>
        <Grid
          container
          sx={{ marginBottom: '20px', marginTop: '20px' }}
          maxWidth="1200px"
          alignItems="center"
        >
          <Grid item width="50%">
            <Stack
              direction="row"
              justifyContent="flex-start"
              width="100%"
              maxHeight="65vh"
              bottom="10vh"
            >
              <JHLogo />
            </Stack>
          </Grid>
          <Grid item width="15%" />
          <Grid item width="35%">
            {!isAuthenticated && !isMaintenance && !isLoading && (
              <CustomButton
                handleOnClick={() =>
                  instance.loginRedirect({
                    redirectUri: '/',
                    redirectStartPage:
                      window.location.pathname === '/'
                        ? '/contracts'
                        : window.location.toString(),
                    scopes: [process.env.REACT_APP_MSAL_SCOPE as string],
                  })
                }
                endIcon={<PersonIcon />}
                fullWidth
                sx={{ height: '5em', fontFamily: 'JHFontBold' }}
                text={t('PleaseLogin')}
              />
            )}
            {isMaintenance && (
              <Typography>{t('MaintenanceInfoText')}</Typography>
            )}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};
